// extracted by mini-css-extract-plugin
export default {"box":"refundFilterPage_box__mtGSL","box__content":"refundFilterPage_box__content__1jBpC","box__content__title":"refundFilterPage_box__content__title__xjJ4D"};